import { AdvanceSalarySearchContext } from "../containers/dashboard/advance-salaries/utils";
import { MiddlewareAction } from "../middleware";

export const enum AdvanceSalaryActions {
  REQUEST_GET_ADVANCE_SALARY = "REQUEST_GET_ADVANCE_SALARY",
  SET_PAGE = "SET_PAGE",
}

export function getAdvanceSalary(
  context: AdvanceSalarySearchContext
): MiddlewareAction {
  const { status } = context;
  const _status = status.toLowerCase();
  return {
    actionName: AdvanceSalaryActions.REQUEST_GET_ADVANCE_SALARY,
    type: "GET",
    url: "/v2/employer-admin/technical-rollover-stu-details",
    params: {
      ...context,
      status: _status,
    },
  };
}

export function setAdvanceSalaryPage(page: number): MiddlewareAction {
  return {
    actionName: AdvanceSalaryActions.SET_PAGE,
    body: { page },
  };
}
